(function () {
    'use strict';
    var toggle = document.querySelector('.gh-burger');
    var menu = document.querySelector('.gh-head-menu');
    function closeMenu() {
        document.body.classList.remove('gh-head-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open navigation');
    }
    if (toggle && menu) {
        var mobileCTA = document.querySelector('.header-cta').cloneNode(true);
        mobileCTA.classList.remove('header-cta');
        mobileCTA.classList.add('mobile-cta');
        menu.appendChild(mobileCTA);
        toggle.addEventListener('click', function () {
            var open = document.body.classList.toggle('gh-head-open');
            toggle.setAttribute('aria-expanded', String(open));
            toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && document.body.classList.contains('gh-head-open')) {closeMenu(); toggle.focus();}
        });
        document.addEventListener('click', function (event) {
            if (!event.target.closest('.gh-head')) closeMenu();
        });
        menu.addEventListener('click', function (event) {if (event.target.closest('a')) closeMenu();});
    }
    document.querySelectorAll('.kg-gallery-image img').forEach(function (img) {
        var width = img.getAttribute('width');
        var height = img.getAttribute('height');
        if (width && height) img.parentElement.style.flex = (width / height) + ' 1 0%';
    });
    document.querySelectorAll('.gh-content iframe[src*="youtube"], .gh-content iframe[src*="vimeo"]').forEach(function (frame) {
        var wrap = document.createElement('div');
        wrap.className = 'responsive-embed';
        frame.parentNode.insertBefore(wrap, frame);
        wrap.appendChild(frame);
    });
    // Only style question/answer lists, leaving instructional bold list items alone.
    document.querySelectorAll('.gh-content li > strong:first-child').forEach(function (strong) {
        if (/\?\s*$/.test(strong.textContent)) {
            strong.parentElement.classList.add('faq-item');
            strong.parentElement.parentElement.classList.add('faq-list');
        }
    });
    var breadcrumb = document.querySelector('.breadcrumb');
    if (breadcrumb) {
        var items = Array.from(breadcrumb.querySelectorAll('a, [aria-current="page"]')).map(function (item, index) {
            return {'@type': 'ListItem', position: index + 1, name: item.textContent.trim(), item: item.href || (document.querySelector('link[rel="canonical"]') || window.location).href};
        });
        var schema = document.createElement('script');
        schema.type = 'application/ld+json';
        schema.textContent = JSON.stringify({'@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: items});
        document.head.appendChild(schema);
    }
    var copy = document.querySelector('.copy-link');
    if (copy) copy.addEventListener('click', function () {
        var status = document.querySelector('.copy-status');
        var url = document.querySelector('link[rel="canonical"]');
        var link = url ? url.href : window.location.href;
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(link).then(function () {status.textContent = 'Link copied!';}, function () {status.textContent = 'Copy this page’s URL from the address bar.';});
        } else {
            status.textContent = 'Copy this page’s URL from the address bar.';
        }
    });
})();
